import VisibilityIconButton from '@features/dashboard/widgets/shared/components/VisibilityIconButton';
import { useScreenSize } from '@hooks/useScreenSize';
import { Button } from '@mui/material';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import TextInput from '@shared/components/TextInput';
import { useState } from 'react';
import { ApiTokenModal } from './ApiTokenModal';
import { CopyButton } from './CopyButton';
import { StyledIconButton } from './StyledIconButton';

type UserInfoBoxProps = {
  label: string;
  apiToken: string;
  recreateToken: () => void;
};

export const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));

export const ApiTokenBox: React.FC<UserInfoBoxProps> = ({ label, apiToken, recreateToken }) => {
  const [hidden, setHidden] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const { isMobile } = useScreenSize();

  return (
    <StyledBox>
      <Box display="flex" flex={1} maxWidth="calc(100% - 220px)">
        <TextInput
          label={label}
          inputProps={{
            name: label,
            readOnly: true,
            type: hidden ? 'text' : 'password',
            value: apiToken,
            sx: { display: 'flex', flex: 1 },
          }}
        />
      </Box>
      <Box sx={{ display: 'flex', marginLeft: 'auto', marginTop: '10px', width: 'fit-content', gap: 1, paddingRight: 1 }}>
        {isMobile ? (
          <StyledIconButton onClick={() => setIsOpen(true)}>
            <i className={'ri-refresh-line'} />
          </StyledIconButton>
        ) : (
          <Button variant="outlined" size="small" color="primary" sx={{ marginRight: 1 }} onClick={() => setIsOpen(true)}>
            Recreate Token
          </Button>
        )}
        <CopyButton message={'API token copied.'} textToCopied={apiToken} />
        <VisibilityIconButton hidden={hidden} onClick={() => setHidden(!hidden)} />
      </Box>
      <ApiTokenModal recreateToken={recreateToken} isOpen={isOpen} setIsOpen={setIsOpen} />
    </StyledBox>
  );
};
